<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Topic</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs" return-object
                        item-value="crs_id" :items="crs_list" item-text="crs_name" label="Course" outlined
                        @change="getchapter()" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" return-object
                        :disabled="crs == null" item-value="ch_id" :items="chapter_list" item-text="ch_name"
                        label="Chapter" outlined @change="getTopic()" />

                </v-col>
            </v-row>
        </v-card>

        <v-card class="box" v-if="chapter != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>{{ crs.crs_name }} : {{ chapter.ch_name }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table :headers="headers" :items="topic_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar flat dense color="white">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Topic</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">Topic</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="crs.crs_name" color="#0F2027" dense disabled
                                                    rounded outlined persistent-hint hint="Course"
                                                    label="Selected Course"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="chapter.ch_name" color="#0F2027" dense disabled
                                                    rounded outlined persistent-hint hint="Chapter"
                                                    label="Selected Chapter"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="topic" color="#0F2027" dense rounded outlined
                                                    persistent-hint hint="Topic Name" label="Topic Name"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4">
                                                <v-checkbox dense v-model="isactive" color="success"
                                                    label="Active"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    /*
        Defines the data used by the component
      */
    data() {
        return {
            load: false,
            loading3: false,
            // extraBreadcrumbItems: [
            //     { text: "Topic Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style1",

            search: "",
            snackbar: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            topic: null,
            topic_list: [],
            courses_list: [],
            chapter_list: [],
            crs_list: null,
            crs: null,
            chapter: null,

            id: null,
            isactive: false,
            dialog: false,
            editedIndex: -1,
            headers: [
                { text: "Chapter Name", value: "topic" },
                { text: "Active", value: "isactive" },
                { text: "Action", value: "action" },
            ],
            output_load: false,
        };
    },

    methods: {
        getCourse() {
            axios
                .post("/QuizQuestionBank/getCourse")
                .then((res) => {
                    this.crs_list = res.data.crs_list;
                    this.quiz_type_list = res.data.quiz_type_list;
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        },
        getchapter() {
            const data = {
                crs_id: this.crs.crs_id
            }
            axios
                .post("/QuizQuestionBank/getchapter", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "Please add chapter for selected course !!!");
                        return
                    }
                    else {
                        this.chapter_list = res.data.chapter_list;
                    }
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        },
        getTopic() {
            const formData = {
                crs_id: this.crs.crs_id,
                ch_id: this.chapter.ch_id,
            };
            axios
                .post("/QuizQuestionBank/topic", formData)
                .then((res) => {
                    this.topic_list = res.data.topic_list;
                    if (this.topic_list.length == 0) {
                        this.showSnackbar("#b71c1c", "Topic not added yet!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        save() {
            if (this.editedIndex == -1) {
                const formData = {
                    crs_id: this.crs.crs_id,
                    ch_id: this.chapter.ch_id,
                    topic_name: this.topic,
                    isactive: this.isactive,
                };
                axios
                    .post("/QuizQuestionBank/saveTopic", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Topic added successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", "Topic already present!!!");
                        }
                        this.getTopic();
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
                this.close();
            } else {

                const formData = {
                    crs_id: this.crs.crs_id,
                    ch_id: this.chapter.ch_id,
                    topic_id: this.id,
                    topic_name: this.topic,
                    isactive: this.isactive,
                };
                axios
                    .post("/QuizQuestionBank/editTopic", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Topic updated successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", "Topic already present!!!");
                        }
                        this.getTopic();
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
                this.close();
            }
        },
        editItem(item) {
            this.editedIndex = this.topic_list.indexOf(item);
            this.id = item.id,
                this.topic = item.topic,
                this.isactive = item.isactive,
                this.dialog = true;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },


        close() {
            this.dialog = false;
            this.dialog_edit = false;
            this.topic = null;
            this.isactive = false;
            this.id = null;
        },
    },
    mounted() {

        // alert(this.type)
        this.getCourse();

    },
};
</script>
<style scoped>
.downbtn {
    float: right;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>
